import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material'
import ColorPicker from 'components/ColorPicker/ColorPicker'
import TextFieldDescribed from 'components/TextFieldDescribed/TextFieldDescribed'
import { useTranslation } from 'react-i18next'
import useMissionStore from 'store/mission'
import { useShallow } from 'zustand/react/shallow'

import style from './VisualSettings.module.css'

const VisualSettings = () => {
  const { t } = useTranslation()
  const { setTempVisualSettings, tempVisualSettings } = useMissionStore(
    useShallow(state => ({
      setTempVisualSettings: state.setTempVisualSettings,
      tempVisualSettings: state.tempVisualSettings,
    }))
  )

  const checkNumberValue = (value: any, divisor?: number) => {
    const number = value == '' ? (divisor != null ? 100 : 0) : value
    return divisor != null ? parseFloat(number) / divisor : parseFloat(number)
  }
  return (
    <Accordion>
      <AccordionSummary>{t('visual_settings.title')}</AccordionSummary>
      <AccordionDetails>
        <div className={style.visualSettingsRow}>
          <TextFieldDescribed
            className={style.textfieldColor}
            description={t('visual_settings.cleanFill')}
            placeholder=""
            value={tempVisualSettings.clean_fill_color}
            disabled={false}
            onChange={e => setTempVisualSettings({ ...tempVisualSettings, clean_fill_color: e.target.value })}
          >
            <ColorPicker
              color={tempVisualSettings.clean_fill_color}
              onChange={colorHex => {
                setTempVisualSettings({ ...tempVisualSettings, clean_fill_color: colorHex })
              }}
            />
          </TextFieldDescribed>
          <TextFieldDescribed
            className={style.textfieldColor}
            description={t('visual_settings.cleanBorder')}
            placeholder=""
            value={tempVisualSettings.clean_border_color}
            disabled={false}
            onChange={e => setTempVisualSettings({ ...tempVisualSettings, clean_border_color: e.target.value })}
          >
            <ColorPicker
              color={tempVisualSettings.clean_border_color}
              onChange={colorHex => {
                setTempVisualSettings({ ...tempVisualSettings, clean_border_color: colorHex })
              }}
            />
          </TextFieldDescribed>
          <TextFieldDescribed
            className={style.textfieldNumber}
            description={t('visual_settings.cleanWidth')}
            placeholder=""
            value={tempVisualSettings.clean_width}
            disabled={false}
            onChange={e => {
              setTempVisualSettings({ ...tempVisualSettings, clean_width: checkNumberValue(e.target.value) })
            }}
          >
            px
          </TextFieldDescribed>
          <TextFieldDescribed
            className={style.textfieldNumber}
            description={t('visual_settings.cleanOpacity')}
            placeholder=""
            value={Math.trunc(tempVisualSettings.clean_opacity * 100)}
            disabled={false}
            onChange={e =>
              setTempVisualSettings({ ...tempVisualSettings, clean_opacity: checkNumberValue(e.target.value, 100) })
            }
          >
            %
          </TextFieldDescribed>
        </div>
        <div className={style.visualSettingsRow}>
          <TextFieldDescribed
            className={style.textfieldColor}
            description={t('visual_settings.restrictFill')}
            placeholder=""
            value={tempVisualSettings.restrict_fill_color}
            disabled={false}
            onChange={e => setTempVisualSettings({ ...tempVisualSettings, restrict_fill_color: e.target.value })}
          >
            <ColorPicker
              color={tempVisualSettings.restrict_fill_color}
              onChange={colorHex => {
                setTempVisualSettings({ ...tempVisualSettings, restrict_fill_color: colorHex })
              }}
            />
          </TextFieldDescribed>
          <TextFieldDescribed
            className={style.textfieldColor}
            description={t('visual_settings.restrictBorder')}
            placeholder=""
            value={tempVisualSettings.restrict_border_color}
            disabled={false}
            onChange={e => setTempVisualSettings({ ...tempVisualSettings, restrict_border_color: e.target.value })}
          >
            <ColorPicker
              color={tempVisualSettings.restrict_border_color}
              onChange={colorHex => {
                setTempVisualSettings({ ...tempVisualSettings, restrict_border_color: colorHex })
              }}
            />
          </TextFieldDescribed>
          <TextFieldDescribed
            className={style.textfieldNumber}
            description={t('visual_settings.restrictWidth')}
            placeholder=""
            value={tempVisualSettings.restrict_width}
            disabled={false}
            onChange={e =>
              setTempVisualSettings({ ...tempVisualSettings, restrict_width: checkNumberValue(e.target.value) })
            }
          >
            px
          </TextFieldDescribed>
          <TextFieldDescribed
            className={style.textfieldNumber}
            description={t('visual_settings.restrictOpacity')}
            placeholder=""
            value={Math.trunc(tempVisualSettings.restrict_opacity * 100)}
            disabled={false}
            onChange={e =>
              setTempVisualSettings({ ...tempVisualSettings, restrict_opacity: checkNumberValue(e.target.value, 100) })
            }
          >
            %
          </TextFieldDescribed>
        </div>
        <div className={style.visualSettingsRow}>
          <TextFieldDescribed
            className={style.textfieldColor}
            description={t('visual_settings.cleaningRouteColor')}
            placeholder=""
            value={tempVisualSettings.cleaning_route_color}
            disabled={false}
            onChange={e => setTempVisualSettings({ ...tempVisualSettings, cleaning_route_color: e.target.value })}
          >
            <ColorPicker
              color={tempVisualSettings.cleaning_route_color}
              onChange={colorHex => {
                setTempVisualSettings({ ...tempVisualSettings, cleaning_route_color: colorHex })
              }}
            />
          </TextFieldDescribed>
          <TextFieldDescribed
            className={style.textfieldNumber}
            description={t('visual_settings.cleaningRouteWidth')}
            placeholder=""
            value={tempVisualSettings.cleaning_route_width}
            disabled={false}
            onChange={e =>
              setTempVisualSettings({ ...tempVisualSettings, cleaning_route_width: checkNumberValue(e.target.value) })
            }
          >
            px
          </TextFieldDescribed>
          <TextFieldDescribed
            className={style.textfieldNumber}
            description={t('visual_settings.cleaningRouteOpacity')}
            placeholder=""
            value={Math.trunc(tempVisualSettings.cleaning_route_opacity * 100)}
            disabled={false}
            onChange={e =>
              setTempVisualSettings({
                ...tempVisualSettings,
                cleaning_route_opacity: checkNumberValue(e.target.value, 100),
              })
            }
          >
            %
          </TextFieldDescribed>
        </div>
        <div className={style.visualSettingsRow}>
          <TextFieldDescribed
            className={style.textfieldColor}
            description={t('visual_settings.transferRouteColor')}
            placeholder=""
            value={tempVisualSettings.transfer_route_color}
            disabled={false}
            onChange={e => setTempVisualSettings({ ...tempVisualSettings, transfer_route_color: e.target.value })}
          >
            <ColorPicker
              color={tempVisualSettings.transfer_route_color}
              onChange={colorHex => {
                setTempVisualSettings({ ...tempVisualSettings, transfer_route_color: colorHex })
              }}
            />
          </TextFieldDescribed>
          <TextFieldDescribed
            className={style.textfieldNumber}
            description={t('visual_settings.transferRouteWidth')}
            placeholder=""
            value={tempVisualSettings.transfer_route_width}
            disabled={false}
            onChange={e =>
              setTempVisualSettings({ ...tempVisualSettings, transfer_route_width: checkNumberValue(e.target.value) })
            }
          >
            px
          </TextFieldDescribed>
          <TextFieldDescribed
            className={style.textfieldNumber}
            description={t('visual_settings.transferRouteOpacity')}
            placeholder=""
            value={Math.trunc(tempVisualSettings.transfer_route_opacity * 100)}
            disabled={false}
            onChange={e =>
              setTempVisualSettings({
                ...tempVisualSettings,
                transfer_route_opacity: checkNumberValue(e.target.value, 100),
              })
            }
          >
            %
          </TextFieldDescribed>
        </div>
      </AccordionDetails>
    </Accordion>
  )
}

export default VisualSettings
